import React from 'react';
import { FaBuilding, FaMapMarkerAlt } from 'react-icons/fa';
import { BsBuilding, BsFlagFill } from 'react-icons/bs';
import { MdExpandMore } from 'react-icons/md';
import { v4 as uuidv4 } from 'uuid';

const timeLineData = [
    {
        id: uuidv4(),
        year: 1979,
        icon: <BsFlagFill />,
        heading: 'Distraco Founded',
        text: 'CV. Diesel Tractor Company (Distraco) was founded in Jakarta and later expanded to Lampung, Sumatra — laying the foundation for heavy equipment parts distribution in Indonesia.',
        transform: '',
    },
    {
        id: uuidv4(),
        year: '1992–2003',
        icon: <MdExpandMore />,
        heading: 'Distraco Expands',
        text: 'Distraco continued its national expansion, opening branches in Pekan Baru (1992), Bandung (2001), and Palembang (2003).',
        transform: 'transform-bottom',
    },
    {
        id: uuidv4(),
        year: 2005,
        icon: <BsBuilding />,
        heading: 'KJD Established',
        text: 'CV. Kalimantan Jaya Diesel was officially founded on March 18, 2005 in Banjarmasin, South Kalimantan, originally operating as the fifth branch of Distraco.',
        transform: '',
    },
    {
        id: uuidv4(),
        year: 2019,
        icon: <FaMapMarkerAlt />,
        heading: 'Samarinda Branch Opens',
        text: 'KJD expanded its own operations in May 2019 by opening a new branch in Samarinda, East Kalimantan.',
        transform: 'transform-bottom',
    },
    {
        id: uuidv4(),
        year: 2022,
        icon: <FaBuilding />,
        heading: 'Three New Branches',
        text: 'KJD grew further with the establishment of three new branches in Kendari (Southeast Sulawesi), Muara Enim (South Sumatra), and DKI Jakarta.',
        transform: '',
    },
];

export default timeLineData;
